import ModuleManager from "../../../framework/core/module_manager";

const { ccclass, property, menu } = cc._decorator;

@ccclass
@menu('custom/UIStateSwitcher')
export default class UIStateSwitcher extends cc.Component {

    showChild(name: string, playAnim = false, needMask = false) {
        let length = this.node.childrenCount
        for (let i = 0; i < length; i++) {
            let child = this.node.children[i]
            if (child.name == name) {
                // if (!child.active && playAnim) {
                //     let mask = this._findMask(child)
                //     let target = child
                //     let mainNode = child.getChildByName("MainNode")
                //     if (mainNode) {
                //         target = mainNode
                //     }
                //     child.active = true
                //     target.active = true
                //     if (mask != null && needMask) {
                //         ModuleManager.instance.playAnim(true, target, mask)
                //     } else {
                //         ModuleManager.instance.playAnim(true, target)
                //     }
                // } else {
                //     child.active = true
                // }
                child.active = true
            } else {
                child.active = false
            }
        }
    }

    _findMask(target: cc.Node) {
        let length = target.childrenCount
        for (let i = 0; i < length; i++) {
            if (target.children[i].name == "Mask") {
                return target.children[i]
            }
        }
        return null
    }

    isChildActive(name: string) {
        let length = this.node.childrenCount
        for (let i = 0; i < length; i++) {
            let child = this.node.children[i]
            if (child.name == name) {
                return child.active
            }
        }
    }

    hasChildActive() {
        let length = this.node.childrenCount
        for (let i = 0; i < length; i++) {
            let child = this.node.children[i]
            if (child.active) {
                return true
            }
        }
        return false
    }

    hideAll() {
        let length = this.node.childrenCount
        for (let i = 0; i < length; i++) {
            this.node.children[i].active = false
        }
    }


}
